
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opportunity-news",
      function () {
        return require("private-next-pages/opportunity-news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opportunity-news"])
      });
    }
  